module.exports = __webpack_public_path__ + "img/al.426dd7db.svg";